import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { AutoPayDialogComponent } from '../auto-pay-dialog/auto-pay-dialog.component';
import { ModalDefaultPaymentComponent } from 'src/app/shared/components/modal-default-payment/modal-default-payment.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { UserService } from 'src/app/shared/services/user.service';
import { GetPayinTokensService } from 'src/app/shared/services/api/get-payin-tokens.service';
import { GetAutoPaySequenceService } from 'src/app/shared/services/api/get-auto-pay-sequence.service';
import { filter, findIndex } from 'rxjs';
import { CreditCard, GetPaymentMethodsRequest, GetPaymentMethodsResponse } from 'src/app/shared/models/authorizeNet.model';
import { AuthorizePaymentService } from 'src/app/shared/services/api/authorize-payment.service';
import { PpiPaymentMethodsService, SetDefaultPaymentRequest } from 'src/app/shared/services/api/ppi-payment-methods.service';
import { HostedPaymentEditPopupComponent } from 'src/app/shared/components/hosted-payment-edit-popup/hosted-payment-edit-popup.component';
import { HostedPaymentPopupComponent } from 'src/app/shared/components/hosted-payment-popup/hosted-payment-popup.component';

@Component({
  selector: 'app-auto-pay',
  templateUrl: './auto-pay.component.html',
  styleUrls: ['./auto-pay.component.scss']
})
export class AutoPayComponent implements OnInit{

  cctokens: CreditCard[] = [];
  selectedtoken: string | null = null;
  paymentTokensAvailable = false;
  isDefaultTokenAvailable = false;
  defaultCard: CreditCard | null = null;
  hasPaymentMethods: boolean = false;

   cardType: any;
  lastFourDigits: any;
  ccExpiration: any;
  isExpired: boolean = false;
  isWarning: boolean = false;

  ONLSessionDetails: any;
  walletDetails: any;

  autopayOptions: any;
  currentSelection: any;
  autopayToggle: boolean = false;
  toggleText: string = 'Off';  // Default toggle text
  toggleChanged: boolean = false;
  canUpdateOrConfirm: boolean = false;


  loading: boolean = false;
  systemError: boolean = false;
  defaultError: boolean = false;
  is4uError: boolean = false;
  successMessage: boolean = false;
  disableButton: boolean = false;
  buttonLoading: boolean = false;
  initialState: any;
  isAutoTransferOn:boolean=false;

  primaryAutoPayCard: any = null; // NEW - hold the real AutoPay card
  isPrimaryAutoPay: boolean = false;

  lastSavedAutoPay: boolean = false;        // what the server says is current
  isWaitingForOffConfirmation: boolean = false; // ON -> OFF pending confirmation

  mainActionButtonText: string = 'Confirm Update';


  private modalOpened: boolean = false; // Add this flag
  isOn = false;
  @Output() toggleChange = new EventEmitter<boolean>();

    constructor(
    private router: Router,
    private dialog: MatDialog,
    public route: ActivatedRoute,
    private userService: UserService,
    public getpayintoken: GetPayinTokensService,
    private getAutoPaySequence: GetAutoPaySequenceService,
    private authorizePaymentService: AuthorizePaymentService,
    private ppiPaymentMethodsService: PpiPaymentMethodsService 
  ) {
    this.ONLSessionDetails = this.userService.getONLSessionDetails();
    // I would want to pull this item directly from sessionStorage, however in fear of potential sync issues I am going to make another call for now in ngOninit
    // this.walletDetails = this.userService.getWalletDetails();
  }

toggle() {
  this.isOn = !this.isOn;
  this.toggleChange.emit(this.isOn);
}

onToggleChange() {
  this.toggleChanged = true;
  this.toggleText = this.autopayToggle ? 'On' : 'Off';

  // If user just switched ON -> OFF (but not confirmed yet),
  // keep radios & confirm enabled until they confirm
  if (this.lastSavedAutoPay === true && this.autopayToggle === false) {
    this.isWaitingForOffConfirmation = true;
  } else {
    this.isWaitingForOffConfirmation = false;
  }
}


  //   ngOnInit() {
   
  //   this.walletDetails = JSON.parse(sessionStorage.getItem('walletDetails')!);
  //   console.log("Wallet Details in Auto Pay Component: ", this.walletDetails);

  //   let autotransfer = JSON.parse(sessionStorage.getItem('AutoTransfer')!);
  //   this.isAutoTransferOn=autotransfer.isAutoTransfer;

  //    this.primaryAutoPayCard = this.walletDetails?.primaryAutoPay || null;
  //    const isDWAutoPayValue = this.walletDetails?.isDWAutoPay;

  //    console.log("Primary Auto Pay: ", this.isPrimaryAutoPay);

  //    this.isPrimaryAutoPay = 
  //         isDWAutoPayValue === true || 
  //         isDWAutoPayValue === 'true' || 
  //         isDWAutoPayValue === 1 || 
  //         isDWAutoPayValue === '1';

  //    const wd = this.walletDetails || {};
  //     if (wd?.isDWAutoPay !== undefined) {
  //       this.autopayToggle =
  //         wd.isDWAutoPay === true ||
  //         wd.isDWAutoPay === 'true' ||
  //         wd.isDWAutoPay === 1 ||
  //         wd.isDWAutoPay === '1';

  //       this.lastSavedAutoPay = this.autopayToggle;       // <— remember server value
  //       this.toggleText = this.autopayToggle ? 'On' : 'Off';
        
  //     }


  //   this.loadPaymentMethods();

  //   this.route.queryParams.subscribe(params => {
  //     if (params['from'] === 'auto-redeem' && this.walletDetails?.defaultPaymentMethod?.toLowerCase() !== 'true') {
  //       // Call your existing modal
       
  //       console.log("default payment method is FALSE from auto-redeem page");
  //     }
  //   });
  // }

  ngOnInit() {
  this.loading = true;

  // Force refresh wallet summary from backend
  this.refreshWalletSummaryFromServer(() => {
    // Once wallet summary is updated, proceed
    this.walletDetails = JSON.parse(sessionStorage.getItem('walletDetails')!);
    console.log("✅ Refreshed Wallet Details in Auto Pay Component: ", this.walletDetails);

    // Handle Auto Transfer
    const autotransfer = JSON.parse(sessionStorage.getItem('AutoTransfer') || '{}');
    this.isAutoTransferOn = autotransfer?.isAutoTransfer || false;

    // Set initial primary and toggle state
    this.primaryAutoPayCard = this.walletDetails?.primaryAutoPay || null;
    const isDWAutoPayValue = this.walletDetails?.isDWAutoPay;

    const normalizeBoolean = (value: any): boolean =>
      value === true || value === 'true' || value === 1 || value === '1';

    this.isPrimaryAutoPay = normalizeBoolean(isDWAutoPayValue);
    this.autopayToggle = this.isPrimaryAutoPay;
    this.toggleText = this.autopayToggle ? 'On' : 'Off';
    this.lastSavedAutoPay = this.autopayToggle;

    // 🔁 Now load the payment methods list
    this.loadPaymentMethods();

    // ✅ Handle query params after everything loaded
    this.route.queryParams.subscribe(params => {
      if (params['from'] === 'auto-redeem' && this.walletDetails?.defaultPaymentMethod?.toLowerCase() !== 'true') {
        console.log("Default payment method is FALSE from auto-redeem page");
      }
    });
  });
}

private refreshWalletSummaryFromServer(callback?: Function) {
  const request = {
    sessionID: sessionStorage.getItem("SessionID"),
    walletID: JSON.parse(sessionStorage.getItem('WalletID') || 'null'),
    walletRole: JSON.parse(sessionStorage.getItem('WalletRole') || 'null')
  };

  this.userService.getWalletSummary(request).subscribe({
    next: (data) => {
      const wallet = data?.ppi?.wallet || data?.onl?.wallet || data?.wallet;
      if (!wallet) {
        console.error('❌ Wallet summary returned empty data');
        this.loading = false;
        return;
      }

      // ✅ Always overwrite sessionStorage to get latest primaryAutoPay
      sessionStorage.setItem('walletDetails', JSON.stringify(wallet));
      this.walletDetails = wallet;
      this.primaryAutoPayCard = wallet.primaryAutoPay || null;

      console.log('✅ Wallet summary refreshed from backend:', wallet);

      this.loading = false;
      if (callback) callback();
    },
    error: (err) => {
      console.error('Error fetching wallet summary:', err);
      this.loading = false;
      if (callback) callback();
    }
  });
}



openAutoPayDialog() {
  this.successMessage = false;

  // 🧩 Fix: only require a card if Auto Pay is being turned ON
  const isTurningOn = this.autopayToggle === true && this.lastSavedAutoPay === false;
  const isTurningOff = this.autopayToggle === false && this.lastSavedAutoPay === true;

  if (!this.selectedtoken && isTurningOn) {
    console.warn('No card selected — required when turning ON Auto Pay');
    return;
  }

  // ✅ If user only changed default card but not the toggle, skip modal
  if (!this.toggleChanged) {
    this.confirmCardChangeOnly();
    return;
  }

  // ✅ Prepare payload for toggle ON/OFF modal
  this.currentSelection = {
    walletID: JSON.parse(sessionStorage.getItem("WalletID") || 'null'),
    walletRole: 'admin',
    sourceSystemID1: sessionStorage.getItem("PPICustomerID"),
    isAutoPay: this.autopayToggle,
    defaultPaymentMethodToken: this.selectedtoken,
    sessionID: sessionStorage.getItem("SessionID"),
    productSystem: 'PPI',
    billingSystem: 'PPI',
    payorID: ''
  };

  // ⚙️ If turning OFF, allow empty token — API should still handle disable request
  if (isTurningOff) {
    this.currentSelection.defaultPaymentMethodToken = this.selectedtoken || '';
  }

  const config = new MatDialogConfig();
  config.autoFocus = false;
  config.data = {
    currentSelection: this.currentSelection,
    autopayOptions: this.autopayOptions || [],
    defaultMethod: this.defaultCard,
    isAutoPay: this.autopayToggle,
    toggleChanged: this.toggleChanged,
    skipFirstStep: false,
    skipConfirmation: false
  };

  const dialogRef = this.dialog.open(AutoPayDialogComponent, config);

  dialogRef.componentInstance.autopayResult.subscribe(result => {
    if (result === true || result === false) {
      this.autopayToggle = result;
      this.toggleText = result ? 'On' : 'Off';
      this.lastSavedAutoPay = result;
      this.isWaitingForOffConfirmation = false;
      this.successMessage = true;

      if (result === false) {
        // Turning OFF — clear local primary info but don't block API
        this.primaryAutoPayCard = null;
        this.selectedtoken = null;
      }

      // Refresh wallet + cards
      this.updateWalletSummary();
    } 
    else if (result === 'cancel') {
      this.autopayToggle = this.lastSavedAutoPay;
      this.toggleText = this.autopayToggle ? 'On' : 'Off';
      this.isWaitingForOffConfirmation = false;
      this.loadPaymentMethods(true);
    } 
    else {
      this.successMessage = false;
    }

    this.toggleChanged = false;
  });
}


openSuccessModalForCardChange() {
    const config = new MatDialogConfig();
    config.autoFocus = false;
    config.data = {
        // Pass minimal data needed for the modal to initialize
        currentSelection: this.currentSelection,
        skipFirstStep: true,      // Tells modal to skip step 0
        skipConfirmation: true,   // Tells modal to start at step 1
        isAutoPay: this.lastSavedAutoPay, // Pass the current ON status
    };
    
    // Open the modal
    this.dialog.open(AutoPayDialogComponent, config);
}

// NEW METHOD
confirmCardChangeOnly() {
    this.buttonLoading = true;
    this.successMessage = false;
    console.log("ConfirmCardUpdate called");

    // 1. Prepare the full DWSetAutoPay payload (like in openAutoPayDialog, but use current state)
    const payload = {
        walletID: this.walletDetails?.walletID, // Use the proper loaded property for stability
        walletRole: 'admin',
        sourceSystemID1: sessionStorage.getItem("PPICustomerID"),
        // CRITICAL: Send the current, saved AutoPay status
        isAutoPay: this.lastSavedAutoPay, 
        // CRITICAL: Send the newly selected card token
        defaultPaymentMethodToken: this.selectedtoken,
        sessionID: sessionStorage.getItem("SessionID"),
        productSystem: 'PPI',
        billingSystem: 'PPI',
        payorID: ''
    };

    // 2. Call the DWSetAutoPay API directly
    this.getAutoPaySequence.setPpiAutoPay(payload).subscribe({
        next: (data) => {
            this.buttonLoading = false;
            if (data.success || data.statusCode === '200') {
                this.successMessage = true;

                // ✅ CRITICAL FIX: OPEN SUCCESS MODAL
                this.openSuccessModalForCardChange();
                // Update the wallet summary to show the new primary card
                this.updateWalletSummary(); 
            } else {
                this.systemError = true;
                console.error('Error updating Primary Auto Pay Card:', data);
            }
        },
        error: (err) => {
            this.buttonLoading = false;
            this.systemError = true;
            console.error('API error updating Primary Auto Pay Card:', err);
        }
    });
}


updateWalletSummary() {
  const request = {
    sessionID: sessionStorage.getItem("SessionID"),
    walletID: JSON.parse(sessionStorage.getItem('WalletID') || 'null'),
    walletRole: JSON.parse(sessionStorage.getItem('WalletRole') || 'null')
  };

  this.userService.getWalletSummary(request).subscribe({
    next: (data) => {
      const wallet = data?.ppi?.wallet || data?.onl?.wallet || data?.wallet;
      if (!wallet) return;

      wallet.isDWAutoPay = this.autopayToggle;
      sessionStorage.setItem('walletDetails', JSON.stringify(wallet));
      this.walletDetails = wallet;

      // Refresh the primary card shown at the top
      this.primaryAutoPayCard = wallet.primaryAutoPay || null;
      this.loadPaymentMethods(true);
      // (Do not change this.autopayToggle here to avoid stale overwrite)
    },
    error: (err) => console.error('Error fetching wallet summary:', err)
  });
}






confirmUpdate() {
  if (!this.selectedtoken) {
    console.warn('No card selected');
    return;
  }

  this.buttonLoading = true;

  const walletId = JSON.parse(sessionStorage.getItem('WalletID') || 'null');
  const sessionId = sessionStorage.getItem('SessionID') || '';
  const userID = sessionStorage.getItem('PPIUserID') || '';
  const customerID = sessionStorage.getItem('PPICustomerID') || '';

  const request: SetDefaultPaymentRequest = {
    userCreditCardID: this.selectedtoken,
    userID,
    customerID,
    sessionID: sessionId,
    walletID: walletId
  };

  this.ppiPaymentMethodsService.setDefaultPaymentMethod(request).subscribe({
    next: (response) => {
      this.buttonLoading = false;
      if (response.statusCode === '200') {
        this.successMessage = true;
        this.loadPaymentMethods();   // ✅ only refresh methods
      } else {
        this.systemError = true;
      }
    },
    error: (err) => {
      this.buttonLoading = false;
      this.systemError = true;
      console.error('Error setting default payment method:', err);
    }
  });
}

// loadPaymentMethods(preserveToggle: boolean = false) {
//   this.loading = true;

//   const walletId = JSON.parse(sessionStorage.getItem("WalletID") || 'null');
//   const sessionId = sessionStorage.getItem("SessionID") || '';
//   const userID = sessionStorage.getItem("PPIUserID") || '';
//   const customerID = sessionStorage.getItem("PPICustomerID") || '';

//   const request: GetPaymentMethodsRequest = {
//     walletID: walletId,
//     userID,
//     customerID,
//     sessionID: sessionId
//   };

//   this.authorizePaymentService.getPaymentMethods(request).subscribe({
//     next: (response: GetPaymentMethodsResponse) => {
//       if (response.ppi?.success && response.ppi.paymentMethods?.length > 0) {
//         this.paymentTokensAvailable = true;
//         this.hasPaymentMethods = true; // 💡 Set flag true that user is NOT first time user
//         this.cctokens = response.ppi.paymentMethods;
//         this.canUpdateOrConfirm = true;

//         this.cctokens.forEach((card: CreditCard) => {
//           card.cardImg = this.getpayintoken.getcardImage(card.creditCardType, '');
//         });

//         // --- Get wallet details from session ---
//         const walletDetails = JSON.parse(sessionStorage.getItem('walletDetails') || '{}');

//          if (!preserveToggle && walletDetails?.isDWAutoPay !== undefined) {
//         const serverAuto =
//           walletDetails.isDWAutoPay === true ||
//           walletDetails.isDWAutoPay === 'true' ||
//           walletDetails.isDWAutoPay === 1 ||
//           walletDetails.isDWAutoPay === '1';

//         this.autopayToggle = serverAuto;
//         this.toggleText = serverAuto ? 'On' : 'Off';
//         this.lastSavedAutoPay = serverAuto;
//       }


//         // 🔑 Prefer Primary AutoPay card from walletDetails
//         if (walletDetails?.primaryAutoPay?.token) {
//           const primaryToken = walletDetails.primaryAutoPay.token;

//           // Find the matching card in the paymentMethods list
//           const primaryCard = this.cctokens.find(
//             c => String(c.userCreditCardId) === String(primaryToken)
//           );

//           if (primaryCard) {
//             this.selectedtoken = primaryCard.userCreditCardId;
//           }
//         }

//         // If no primaryAutoPay match, fallback to default card
//         if (!this.selectedtoken) {
//           const defaultCard = this.cctokens.find(
//             c => String(c.isDefault).toLowerCase() === 'true'
//           ) || null;

//           if (defaultCard) {
//             this.selectedtoken = defaultCard.userCreditCardId;
//           }
//         }

//         // --- Normalize autopay toggle ---
//         if (walletDetails?.isDWAutoPay !== undefined) {
//           this.autopayToggle =
//             walletDetails.isDWAutoPay === true ||
//             walletDetails.isDWAutoPay === 'true' ||
//             walletDetails.isDWAutoPay === 1 ||
//             walletDetails.isDWAutoPay === '1';

//           this.toggleText = this.autopayToggle ? 'On' : 'Off';
//         }

//         // Button text logic

//       if (this.autopayToggle && this.selectedtoken) {
//             this.mainActionButtonText = 'Confirm Update';
//         } else {
//             this.mainActionButtonText = 'Confirm Update';
//         }

//       } else {
//         this.paymentTokensAvailable = false;
//         this.hasPaymentMethods = false; // 💡 Set flag for first-time user / no card
//         this.cctokens = [];
//         this.selectedtoken = null;
//         this.canUpdateOrConfirm = false;
//       }

//       this.loading = false;
//     },
//     error: (error) => {
//       console.error('Error fetching payment methods:', error);
//       this.systemError = true;
//       this.loading = false;
//     }
//   });
// }

loadPaymentMethods(preserveToggle: boolean = false) {
  this.loading = true;

  const walletId = JSON.parse(sessionStorage.getItem("WalletID") || 'null');
  const sessionId = sessionStorage.getItem("SessionID") || '';
  const userID = sessionStorage.getItem("PPIUserID") || '';
  const customerID = sessionStorage.getItem("PPICustomerID") || '';

  const request: GetPaymentMethodsRequest = { walletID: walletId, userID, customerID, sessionID: sessionId };

  this.authorizePaymentService.getPaymentMethods(request).subscribe({
    next: (response: GetPaymentMethodsResponse) => {
      const walletDetails = JSON.parse(sessionStorage.getItem('walletDetails') || '{}');

      // ✅ Always set primary card from wallet details (even before checking payment list)
      this.primaryAutoPayCard = walletDetails?.primaryAutoPay || null;
      const primaryToken = this.primaryAutoPayCard?.token || null;

      // Normalize boolean for AutoPay
      const normalizeBoolean = (value: any): boolean =>
        value === true || value === 'true' || value === 1 || value === '1';

      // ✅ Keep autopay state synced
      this.isPrimaryAutoPay = normalizeBoolean(walletDetails?.isDWAutoPay);
      this.autopayToggle = this.isPrimaryAutoPay;
      this.toggleText = this.autopayToggle ? 'On' : 'Off';
      this.lastSavedAutoPay = this.autopayToggle;

      // ✅ Mark hasPaymentMethods true if either payment list OR primary card exist
      const hasCards = response.ppi?.success && response.ppi.paymentMethods?.length > 0;
      this.hasPaymentMethods = hasCards || !!primaryToken;
      this.paymentTokensAvailable = hasCards;
      this.canUpdateOrConfirm = hasCards;

      // Assign list of cards (if present)
      this.cctokens = hasCards ? response.ppi.paymentMethods : [];
      this.cctokens.forEach((card: CreditCard) => {
        card.cardImg = this.getpayintoken.getcardImage(card.creditCardType, '');
      });

      // If primary token exists, select it
      if (primaryToken && this.cctokens.length > 0) {
        const match = this.cctokens.find(
          c => String(c.userCreditCardId) === String(primaryToken)
        );
        if (match) this.selectedtoken = match.userCreditCardId;
      }

      this.mainActionButtonText = 'Confirm Update';
      this.loading = false;
    },
    error: (error) => {
      console.error('Error fetching payment methods:', error);
      this.systemError = true;
      this.loading = false;
    }
  });
}



   editPaymentMethod(card: CreditCard) {
    // this.router.navigate([`/hosted-payment-edit/${card.userCreditCardId}`]);
    // 1. Set up dialog configuration
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true; // Prevent closing by clicking outside or pressing ESC
    dialogConfig.width = '600px';
    
    // Pass the required card ID to the modal via the data property
    dialogConfig.data = { userCreditCardID: card.userCreditCardId }; 

    // 2. Open the modal
    const dialogRef = this.dialog.open(HostedPaymentEditPopupComponent, dialogConfig);
    
    // 3. Subscribe to the result of the modal when it closes
    dialogRef.afterClosed().subscribe(result => {
        // 'success' is returned if the edit was successful (e.g., Notify API called)
        if (result === 'success') {
            console.log('Payment Edit modal closed successfully. Refreshing card list.');
            
            // Re-fetch payment methods to show the updated card details (last4 or expiration)
            this.loadPaymentMethods(true); // Preserve the current toggle state
            
        } else if (result === 'cancel') {
            console.log('Payment Edit modal closed/cancelled.');
        }
    });
  }

// Replace the existing method with this modal logic
addNewPaymentMethod() {
    //  OLD: this.router.navigate(['/hosted-payment']);

    //  NEW: Open the Hosted Payment Modal/Flyout

    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '600px';
    dialogConfig.height = '600px';
    dialogConfig.disableClose = true; // Prevent closing by clicking outside during process
        
    const dialogRef = this.dialog.open(HostedPaymentPopupComponent, dialogConfig);
    
    // Subscribe to the result of the modal when it closes
    dialogRef.afterClosed().subscribe(result => {
        if (result === 'success') {
            console.log('Payment modal closed successfully. Refreshing card list.');
            // If the modal closed with 'success', refresh the card list
            this.loadPaymentMethods(); 
        } else {
            console.log('Payment modal closed without success result:', result);
        }
    });

    console.log('AutoPayComponent: Opening hosted-payment modal.');
}

}
